import styles from "./CarsSummary.module.css";
import { useEffect, useState } from "react";
import getCarsSummary from "../../utils/getCarsSummary";
import Skeleton from "@mui/material/Skeleton";

const MaagarCarsSummary = () => {
  interface Summary {
    totalCars: number;
    tsumodCars: number;
    maagarCars: number;
    rentedCars: number;
    activeRentedCars: number;
    expiredRentedCars: number;
    carsWithFuelCodes: number;
    carsWithoutFuelCodes: number;
    tsumodCarsWithFuelCodes: number;
    maagarCarsWithFuelCodes: number;
    rentedCarsWithFuelCodes: number;
  }

  const [summary, setSummary] = useState<Summary | null>(null);
  const [loading, setLoading] = useState(true);
  const [reloadTrigger, setReloadTrigger] = useState(0);

  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      try {
        const data = await getCarsSummary();
        setSummary(data);
      } catch (error) {
        console.error("Error fetching cars summary:", error);
      }
      setLoading(false);
    };
    fetchSummary();
  }, [reloadTrigger]);

  // Listen to global reload events
  useEffect(() => {
    const handleReload = () => setReloadTrigger(prev => prev + 1);
    window.addEventListener('reloadCarsSummary', handleReload);
    return () => window.removeEventListener('reloadCarsSummary', handleReload);
  }, []);

  return (
    <div className={styles.summaryContainer}>
      {loading ? (
        <>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>סה״כ רכבי מאגר:</div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>רכבים שקיבלו מספרי תדלוק:</div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>סה״כ רכבי מאגר:</div>
            <div className={styles.summaryItemValue}>{summary?.maagarCars}</div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>רכבים שקיבלו מספרי תדלוק:</div>
            <div className={styles.summaryItemValue}>{summary?.maagarCarsWithFuelCodes}</div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>עדיין לא קיבלו:</div>
            <div className={styles.summaryItemValue}>
              {summary ? (summary.maagarCars - summary.maagarCarsWithFuelCodes) : 0}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MaagarCarsSummary;
